export const exampleKpiList = {
  users: { label: 'Users', value: 38 },
  sessions: { label: 'Sessions', value: 42 },
  events: { label: 'Events', value: 55 },
  revenue: { label: 'Revenue (USD)', value: '$0.00' },
  purchases: { label: 'Purchases', value: 0 },
  cvr: { label: 'Purchase CVR', value: '0.00%' },
  arpp: { label: 'Avg Rev / Purchase', value: '$0.00' },
  rows: { label: 'Raw Rows', value: 500 }
}

export const exampleComputedStats = {
  users: [
    1605951.6059719725, 2163283.4364849087, 3886972.1560030556,
    5057241.750802934, 6475141.654587744, 7048148.009594872, 11717984.943483878,
    30900021.323378697, 51332807.24462119, 61031472.87103895, 73168181.25516365,
    78087117.25633365, 1009676.4905193951, 1172211.4577928963,
    1235093.1800599373, 1580194.1306638243, 1621047.1809785713,
    1708340.3854978106, 1865955.6072229585, 1989653.0310679977,
    2093349.3276106748, 2126401.40854538, 2219098.9178831126,
    2230905.7046198924, 2325507.2899863417, 2351306.620910962,
    2384954.218745844, 2510026.345211138, 2589768.439253248, 2889241.838178414,
    3531543.061725483, 4011791.2269121925, 4239675.220679819, 5188370.382780906,
    5428986.989179107, 5612330.689277568, 5733492.116239125, 5971348.017087772
  ],
  sessions: [
    '2725571477',
    '9278676056',
    '4344470266',
    '9009371496',
    '9627797947',
    '2634310464',
    '1085011694',
    '3003908783',
    '6465097438',
    '1027719877',
    '6832949273',
    '4609872843',
    '9604048120',
    '2556756031',
    '7808177356',
    '571195322',
    '5815112154',
    '1594094923',
    '1882783048',
    '3823848748',
    '9813682590',
    '2449606776',
    '2558933406',
    '6149139412',
    '3659737217',
    '3426007513',
    '9157144569',
    '716804610',
    '1109039738',
    '5474366524',
    '9622942430',
    '4533886078',
    '9763169697',
    '1372810478',
    '5898277976',
    '3702926601',
    '2175581168',
    '77729219',
    '9674589155',
    '3704594243',
    '5060149289',
    '6478020992'
  ],
  purchases: 0,
  revenue: 0,
  byDate: {
    20210102: { events: 3, revenue: 0 },
    20210103: { events: 2, revenue: 0 },
    20210105: { events: 1, revenue: 0 },
    20210106: { events: 3, revenue: 0 },
    20210107: { events: 1, revenue: 0 },
    20210108: { events: 1, revenue: 0 },
    20210112: { events: 8, revenue: 0 },
    20210113: { events: 3, revenue: 0 },
    20210114: { events: 2, revenue: 0 },
    20210115: { events: 1, revenue: 0 },
    20210116: { events: 2, revenue: 0 },
    20210117: { events: 7, revenue: 0 },
    20210118: { events: 2, revenue: 0 },
    20210120: { events: 1, revenue: 0 },
    20210121: { events: 2, revenue: 0 },
    20210122: { events: 6, revenue: 0 },
    20210125: { events: 1, revenue: 0 },
    20210126: { events: 3, revenue: 0 },
    20210127: { events: 2, revenue: 0 },
    20210128: { events: 2, revenue: 0 },
    20210129: { events: 1, revenue: 0 },
    20210131: { events: 1, revenue: 0 }
  },
  eventCounts: {
    page_view: 13,
    view_promotion: 7,
    session_start: 8,
    first_visit: 5,
    user_engagement: 7,
    scroll: 11,
    view_item: 3,
    select_promotion: 1
  },
  deviceGroupCounts: { mobile: 18, desktop: 37 },
  deviceCombos: {
    'mobile / Safari': 5,
    'desktop / Chrome': 31,
    'desktop / Safari': 4,
    'mobile / Chrome': 12,
    'desktop / Edge': 2,
    'mobile / <Other>': 1
  },
  mediumSorted: [
    ['organic', 19],
    ['referral', 15],
    ['(none)', 13],
    ['<Other>', 6],
    ['(data deleted)', 1],
    ['cpc', 1]
  ],
  funnel: { view_item: 3, add_to_cart: 0, begin_checkout: 0, purchase: 0 }
}

export const exampleEvents = [
  {
    __id: '1611210000000000|1605951.6059719725|page_view|-307340413',
    event_date: 20210121,
    event_timestamp: 1611210000000000,
    event_name: 'page_view',
    user_pseudo_id: 1605951.6059719725,
    traffic_medium: '(none)',
    device_category: 'mobile',
    browser: 'Safari',
    device_detail: 'mobile / Safari',
    event_value_in_usd: 0,
    params: {
      engagement_time_msec: 13,
      debug_mode: 1,
      ga_session_number: 1,
      page_location: 'https://www.googlemerchandisestore.com/',
      ga_session_id: 2725571477,
      session_engaged: 1,
      engaged_session_event: 1,
      page_title: 'Google Online Store'
    },
    ga_session_id: 2725571477
  },
  {
    __id: '1611210000000000|1605951.6059719725|page_view|-311704457',
    event_date: 20210121,
    event_timestamp: 1611210000000000,
    event_name: 'page_view',
    user_pseudo_id: 1605951.6059719725,
    traffic_medium: '(none)',
    device_category: 'mobile',
    browser: 'Safari',
    device_detail: 'mobile / Safari',
    event_value_in_usd: 0,
    params: {
      clean_event: 'gtm.js',
      entrances: 1,
      session_engaged: 0,
      ga_session_id: 2725571477,
      page_title: 'Google Online Store',
      engaged_session_event: 1,
      ga_session_number: 1,
      campaign: '(direct)',
      term: '<obfuscated>',
      debug_mode: 1,
      source: '(direct)',
      page_location: 'https://www.googlemerchandisestore.com/',
      medium: '(none)'
    },
    ga_session_id: 2725571477
  },
  {
    __id: '1611960000000000|2163283.4364849087|view_promotion|-6653755973',
    event_date: 20210129,
    event_timestamp: 1611960000000000,
    event_name: 'view_promotion',
    user_pseudo_id: 2163283.4364849087,
    traffic_medium: '(none)',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      ga_session_number: 1,
      engagement_time_msec: 46,
      page_title: 'Home',
      engaged_session_event: 1,
      debug_mode: 1,
      ga_session_id: 9278676056,
      page_location: 'https://shop.googlemerchandisestore.com/',
      session_engaged: 1
    },
    ga_session_id: 9278676056
  },
  {
    __id: '1609700000000000|3886972.1560030556|session_start|-6411002457',
    event_date: 20210103,
    event_timestamp: 1609700000000000,
    event_name: 'session_start',
    user_pseudo_id: 3886972.1560030556,
    traffic_medium: '<Other>',
    device_category: 'desktop',
    browser: 'Safari',
    device_detail: 'desktop / Safari',
    event_value_in_usd: 0,
    params: {
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel',
      ga_session_number: 1,
      ga_session_id: 4344470266,
      page_title: 'Apparel | Google Merchandise Store',
      engaged_session_event: 1
    },
    ga_session_id: 4344470266
  },
  {
    __id: '1610550000000000|5057241.750802934|first_visit|1236656593',
    event_date: 20210113,
    event_timestamp: 1610550000000000,
    event_name: 'first_visit',
    user_pseudo_id: 5057241.750802934,
    traffic_medium: 'organic',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel',
      engaged_session_event: 1,
      session_engaged: 1,
      page_title: 'Apparel | Google Merchandise Store',
      ga_session_id: 9009371496,
      ga_session_number: 1
    },
    ga_session_id: 9009371496
  },
  {
    __id: '1610910000000000|6475141.654587744|page_view|-5200104759',
    event_date: 20210117,
    event_timestamp: 1610910000000000,
    event_name: 'page_view',
    user_pseudo_id: 6475141.654587744,
    traffic_medium: 'organic',
    device_category: 'desktop',
    browser: 'Safari',
    device_detail: 'desktop / Safari',
    event_value_in_usd: 0,
    params: {
      entrances: 1,
      page_location: 'https://shop.googlemerchandisestore.com/signin.html',
      debug_mode: 1,
      engaged_session_event: 1,
      ga_session_number: 1,
      ga_session_id: 9627797947,
      page_title: 'The Google Merchandise Store - Log In',
      session_engaged: 0,
      clean_event: 'gtm.js'
    },
    ga_session_id: 9627797947
  },
  {
    __id: '1610780000000000|7048148.009594872|user_engagement|-2956234537',
    event_date: 20210116,
    event_timestamp: 1610780000000000,
    event_name: 'user_engagement',
    user_pseudo_id: 7048148.009594872,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      session_engaged: 0,
      medium: 'referral',
      debug_mode: 1,
      page_location:
        'https://shop.googlemerchandisestore.com/google+redesign/apparel/google+dino+game+tee',
      ga_session_number: 2,
      page_title: 'Page Unavailable',
      source: 'shop.googlemerchandisestore.com',
      campaign: '(referral)',
      ga_session_id: 2634310464
    },
    ga_session_id: 2634310464
  },
  {
    __id: '1612080000000000|11717984.943483878|session_start|-9705040760',
    event_date: 20210131,
    event_timestamp: 1612080000000000,
    event_name: 'session_start',
    user_pseudo_id: 11717984.943483878,
    traffic_medium: 'organic',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      ga_session_id: 1085011694,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel',
      page_title: 'Apparel | Google Merchandise Store',
      ga_session_number: 1,
      engaged_session_event: 1
    },
    ga_session_id: 1085011694
  },
  {
    __id: '1610080000000000|30900021.323378697|view_promotion|-2904941205',
    event_date: 20210108,
    event_timestamp: 1610080000000000,
    event_name: 'view_promotion',
    user_pseudo_id: 30900021.323378697,
    traffic_medium: '(none)',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      session_engaged: 1,
      engagement_time_msec: 13,
      page_location: 'https://shop.googlemerchandisestore.com/',
      engaged_session_event: 1,
      page_title: 'Home',
      debug_mode: 1,
      ga_session_number: 9,
      ga_session_id: 3003908783
    },
    ga_session_id: 3003908783
  },
  {
    __id: '1611880000000000|51332807.24462119|scroll|-6399212118',
    event_date: 20210128,
    event_timestamp: 1611880000000000,
    event_name: 'scroll',
    user_pseudo_id: 51332807.24462119,
    traffic_medium: '<Other>',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      source: 'shop.googlemerchandisestore.com',
      engaged_session_event: 1,
      medium: 'referral',
      page_referrer:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel?',
      ga_session_id: 6465097438,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel/Womens',
      page_title: 'Womens | Apparel | Google Merchandise Store',
      debug_mode: 1,
      ga_session_number: 1,
      campaign: '(referral)',
      session_engaged: 1,
      percent_scrolled: 90,
      engagement_time_msec: 12285
    },
    ga_session_id: 6465097438
  },
  {
    __id: '1610900000000000|61031472.87103895|scroll|-2892981018',
    event_date: 20210117,
    event_timestamp: 1610900000000000,
    event_name: 'scroll',
    user_pseudo_id: 61031472.87103895,
    traffic_medium: '(none)',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      ga_session_number: 3,
      debug_mode: 1,
      ga_session_id: 1027719877,
      percent_scrolled: 90,
      session_engaged: 1,
      engagement_time_msec: 21145,
      page_location: 'https://shop.googlemerchandisestore.com/',
      engaged_session_event: 1,
      page_title: 'Home'
    },
    ga_session_id: 1027719877
  },
  {
    __id: '1610870000000000|61031472.87103895|first_visit|7788820090',
    event_date: 20210117,
    event_timestamp: 1610870000000000,
    event_name: 'first_visit',
    user_pseudo_id: 61031472.87103895,
    traffic_medium: 'organic',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      page_location: 'https://shop.googlemerchandisestore.com/',
      page_title: 'Home',
      engaged_session_event: 1,
      session_engaged: 1,
      ga_session_id: 6832949273,
      ga_session_number: 1
    },
    ga_session_id: 6832949273
  },
  {
    __id: '1610870000000000|61031472.87103895|scroll|8772829560',
    event_date: 20210117,
    event_timestamp: 1610870000000000,
    event_name: 'scroll',
    user_pseudo_id: 61031472.87103895,
    traffic_medium: '(data deleted)',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Stationery',
      engagement_time_msec: 19564,
      engaged_session_event: 1,
      percent_scrolled: 90,
      page_title: 'Stationery | Google Merchandise Store',
      ga_session_id: 4609872843,
      page_referrer:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Lifestyle?',
      ga_session_number: 2,
      debug_mode: 1,
      session_engaged: 1
    },
    ga_session_id: 4609872843
  },
  {
    __id: '1610900000000000|61031472.87103895|view_promotion|6686383341',
    event_date: 20210117,
    event_timestamp: 1610900000000000,
    event_name: 'view_promotion',
    user_pseudo_id: 61031472.87103895,
    traffic_medium: '(none)',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      debug_mode: 1,
      page_title: 'Home',
      ga_session_number: 3,
      session_engaged: 1,
      ga_session_id: 1027719877,
      engagement_time_msec: 72,
      page_location: 'https://shop.googlemerchandisestore.com/',
      engaged_session_event: 1
    },
    ga_session_id: 1027719877
  },
  {
    __id: '1610910000000000|73168181.25516365|first_visit|8371356105',
    event_date: 20210117,
    event_timestamp: 1610910000000000,
    event_name: 'first_visit',
    user_pseudo_id: 73168181.25516365,
    traffic_medium: 'organic',
    device_category: 'desktop',
    browser: 'Safari',
    device_detail: 'desktop / Safari',
    event_value_in_usd: 0,
    params: {
      engaged_session_event: 1,
      ga_session_id: 9604048120,
      page_title: 'Home',
      page_location: 'https://shop.googlemerchandisestore.com/store.html',
      session_engaged: 1,
      ga_session_number: 1
    },
    ga_session_id: 9604048120
  },
  {
    __id: '1610910000000000|73168181.25516365|session_start|8371356105',
    event_date: 20210117,
    event_timestamp: 1610910000000000,
    event_name: 'session_start',
    user_pseudo_id: 73168181.25516365,
    traffic_medium: 'organic',
    device_category: 'desktop',
    browser: 'Safari',
    device_detail: 'desktop / Safari',
    event_value_in_usd: 0,
    params: {
      ga_session_number: 1,
      ga_session_id: 9604048120,
      page_location: 'https://shop.googlemerchandisestore.com/store.html',
      engaged_session_event: 1,
      page_title: 'Home'
    },
    ga_session_id: 9604048120
  },
  {
    __id: '1610490000000000|78087117.25633365|page_view|-3249182755',
    event_date: 20210112,
    event_timestamp: 1610490000000000,
    event_name: 'page_view',
    user_pseudo_id: 78087117.25633365,
    traffic_medium: 'organic',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      engaged_session_event: 1,
      page_title: 'Google Chrome Dino Light Up Water Bottle',
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Google+Chrome+Dino+Light+Up+Water+Bottle',
      debug_mode: 1,
      session_engaged: 1,
      clean_event: 'gtm.js',
      ga_session_number: 1,
      ga_session_id: 2556756031
    },
    ga_session_id: 2556756031
  },
  {
    __id: '1610490000000000|78087117.25633365|scroll|8291792353',
    event_date: 20210112,
    event_timestamp: 1610490000000000,
    event_name: 'scroll',
    user_pseudo_id: 78087117.25633365,
    traffic_medium: 'organic',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Lifestyle/Drinkware',
      percent_scrolled: 90,
      debug_mode: 1,
      session_engaged: 1,
      engaged_session_event: 1,
      medium: 'organic',
      source: 'google',
      ga_session_number: 1,
      engagement_time_msec: 23100,
      page_referrer:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Shop+by+Brand/Google?',
      campaign: '(organic)',
      page_title: 'Drinkware | Lifestyle | Google Merchandise Store',
      ga_session_id: 2556756031
    },
    ga_session_id: 2556756031
  },
  {
    __id: '1611700000000000|1009676.4905193951|page_view|9448114128',
    event_date: 20210126,
    event_timestamp: 1611700000000000,
    event_name: 'page_view',
    user_pseudo_id: 1009676.4905193951,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      ga_session_id: 7808177356,
      engaged_session_event: 1,
      debug_mode: 1,
      engagement_time_msec: 5,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Bags',
      session_engaged: 1,
      page_title: 'Page Unavailable',
      ga_session_number: 2
    },
    ga_session_id: 7808177356
  },
  {
    __id: '1611700000000000|1009676.4905193951|user_engagement|1548952687',
    event_date: 20210126,
    event_timestamp: 1611700000000000,
    event_name: 'user_engagement',
    user_pseudo_id: 1009676.4905193951,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      engagement_time_msec: 1622,
      ga_session_id: 7808177356,
      debug_mode: 1,
      engaged_session_event: 1,
      page_title: 'Page Unavailable',
      session_engaged: 1,
      ga_session_number: 2,
      page_location:
        'https://shop.googlemerchandisestore.com/google+redesign/apparel/google+womens+tee+fc+black'
    },
    ga_session_id: 7808177356
  },
  {
    __id: '1611710000000000|1009676.4905193951|view_promotion|3263207752',
    event_date: 20210127,
    event_timestamp: 1611710000000000,
    event_name: 'view_promotion',
    user_pseudo_id: 1009676.4905193951,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      session_engaged: 1,
      engaged_session_event: 1,
      engagement_time_msec: 51,
      ga_session_number: 3,
      debug_mode: 1,
      ga_session_id: 571195322,
      page_title: 'Home',
      page_location: 'https://shop.googlemerchandisestore.com/'
    },
    ga_session_id: 571195322
  },
  {
    __id: '1610050000000000|1172211.4577928963|scroll|-3141672357',
    event_date: 20210107,
    event_timestamp: 1610050000000000,
    event_name: 'scroll',
    user_pseudo_id: 1172211.4577928963,
    traffic_medium: 'organic',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      engaged_session_event: 1,
      debug_mode: 1,
      ga_session_number: 1,
      page_referrer: 'https://shop.googlemerchandisestore.com/register.html?',
      page_location:
        'https://shop.googlemerchandisestore.com/registersuccess.html',
      engagement_time_msec: 237,
      session_engaged: 1,
      percent_scrolled: 90,
      page_title: 'The Google Merchandise Store - Log In',
      ga_session_id: 5815112154
    },
    ga_session_id: 5815112154
  },
  {
    __id: '1610440000000000|1235093.1800599373|scroll|-8586581006',
    event_date: 20210112,
    event_timestamp: 1610440000000000,
    event_name: 'scroll',
    user_pseudo_id: 1235093.1800599373,
    traffic_medium: '<Other>',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      debug_mode: 1,
      page_location: 'https://googlemerchandisestore.com/',
      page_title: 'Google Online Store',
      session_engaged: 1,
      engaged_session_event: 1,
      percent_scrolled: 90,
      ga_session_number: 1,
      ga_session_id: 1594094923,
      engagement_time_msec: 1373
    },
    ga_session_id: 1594094923
  },
  {
    __id: '1610700000000000|1580194.1306638243|scroll|-429085143',
    event_date: 20210115,
    event_timestamp: 1610700000000000,
    event_name: 'scroll',
    user_pseudo_id: 1580194.1306638243,
    traffic_medium: 'organic',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      engagement_time_msec: 23930,
      page_referrer:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel?',
      engaged_session_event: 1,
      percent_scrolled: 90,
      page_title: 'Bags | Lifestyle | Google Merchandise Store',
      ga_session_number: 1,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Lifestyle/Bags',
      debug_mode: 1,
      session_engaged: 1,
      ga_session_id: 1882783048
    },
    ga_session_id: 1882783048
  },
  {
    __id: '1609620000000000|1621047.1809785713|session_start|-4446408852',
    event_date: 20210102,
    event_timestamp: 1609620000000000,
    event_name: 'session_start',
    user_pseudo_id: 1621047.1809785713,
    traffic_medium: '(none)',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      page_title: 'Google Online Store',
      ga_session_number: 1,
      page_location: 'https://googlemerchandisestore.com/',
      engaged_session_event: 1,
      ga_session_id: 3823848748
    },
    ga_session_id: 3823848748
  },
  {
    __id: '1610530000000000|1708340.3854978106|user_engagement|7862834581',
    event_date: 20210113,
    event_timestamp: 1610530000000000,
    event_name: 'user_engagement',
    user_pseudo_id: 1708340.3854978106,
    traffic_medium: 'referral',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      page_title: 'Bags | Lifestyle | Google Merchandise Store',
      engagement_time_msec: 9145,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Lifestyle/Bags',
      engaged_session_event: 1,
      ga_session_id: 9813682590,
      source: 'shop.googlemerchandisestore.com',
      debug_mode: 1,
      campaign: '(referral)',
      ga_session_number: 2,
      medium: 'referral',
      session_engaged: 1
    },
    ga_session_id: 9813682590
  },
  {
    __id: '1610530000000000|1708340.3854978106|scroll|-7288217621',
    event_date: 20210113,
    event_timestamp: 1610530000000000,
    event_name: 'scroll',
    user_pseudo_id: 1708340.3854978106,
    traffic_medium: 'organic',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      percent_scrolled: 90,
      session_engaged: 1,
      ga_session_number: 1,
      page_title: 'Google Online Store',
      page_location: 'https://googlemerchandisestore.com/',
      ga_session_id: 2449606776,
      debug_mode: 1,
      engagement_time_msec: 43,
      engaged_session_event: 1
    },
    ga_session_id: 2449606776
  },
  {
    __id: '1611310000000000|1865955.6072229585|page_view|1941546005',
    event_date: 20210122,
    event_timestamp: 1611310000000000,
    event_name: 'page_view',
    user_pseudo_id: 1865955.6072229585,
    traffic_medium: '(none)',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      ga_session_id: 2558933406,
      page_title: "Men's T-Shirts | Apparel | Google Merchandise Store",
      engaged_session_event: 1,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel/Mens/Mens+T+Shirts',
      debug_mode: 1,
      campaign: '(organic)',
      engagement_time_msec: 4,
      medium: 'organic',
      session_engaged: 1,
      ga_session_number: 1,
      source: 'google',
      term: '<obfuscated>'
    },
    ga_session_id: 2558933406
  },
  {
    __id: '1611310000000000|1865955.6072229585|page_view|-2956879375',
    event_date: 20210122,
    event_timestamp: 1611310000000000,
    event_name: 'page_view',
    user_pseudo_id: 1865955.6072229585,
    traffic_medium: '(none)',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      debug_mode: 1,
      session_engaged: 1,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Campus+Collection',
      engaged_session_event: 1,
      ga_session_id: 2558933406,
      page_title: 'Campus Collection | Google Merchandise Store',
      engagement_time_msec: 3,
      ga_session_number: 1
    },
    ga_session_id: 2558933406
  },
  {
    __id: '1611310000000000|1865955.6072229585|view_item|3197187060',
    event_date: 20210122,
    event_timestamp: 1611310000000000,
    event_name: 'view_item',
    user_pseudo_id: 1865955.6072229585,
    traffic_medium: '(none)',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel/Mens/Mens+T+Shirts',
      debug_mode: 1,
      ga_session_id: 2558933406,
      page_title: "Men's T-Shirts | Apparel | Google Merchandise Store",
      ga_session_number: 1,
      engagement_time_msec: 502,
      session_engaged: 1,
      engaged_session_event: 1
    },
    ga_session_id: 2558933406
  },
  {
    __id: '1609570000000000|1989653.0310679977|session_start|-7745393035',
    event_date: 20210102,
    event_timestamp: 1609570000000000,
    event_name: 'session_start',
    user_pseudo_id: 1989653.0310679977,
    traffic_medium: 'organic',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      engaged_session_event: 1,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel',
      ga_session_number: 1,
      ga_session_id: 6149139412,
      page_title: 'Apparel | Google Merchandise Store'
    },
    ga_session_id: 6149139412
  },
  {
    __id: '1610450000000000|2093349.3276106748|page_view|5033289653',
    event_date: 20210112,
    event_timestamp: 1610450000000000,
    event_name: 'page_view',
    user_pseudo_id: 2093349.3276106748,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      page_location: 'https://shop.googlemerchandisestore.com/',
      campaign: 'Data Share Promo',
      medium: 'affiliate',
      clean_event: 'gtm.js',
      ga_session_id: 3659737217,
      session_engaged: 0,
      source: 'Partners',
      engaged_session_event: 1,
      debug_mode: 1,
      ga_session_number: 3,
      page_title: 'Home',
      entrances: 1
    },
    ga_session_id: 3659737217
  },
  {
    __id: '1611660000000000|2126401.40854538|page_view|2243610303',
    event_date: 20210126,
    event_timestamp: 1611660000000000,
    event_name: 'page_view',
    user_pseudo_id: 2126401.40854538,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      engagement_time_msec: 6,
      ga_session_number: 2,
      engaged_session_event: 1,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Shop+by+Brand/Google+Cloud',
      session_engaged: 1,
      debug_mode: 1,
      ga_session_id: 3426007513,
      page_title: 'Google Cloud | Shop by Brand | Google Merchandise Store'
    },
    ga_session_id: 3426007513
  },
  {
    __id: '1611840000000000|2126401.40854538|scroll|6307239440',
    event_date: 20210128,
    event_timestamp: 1611840000000000,
    event_name: 'scroll',
    user_pseudo_id: 2126401.40854538,
    traffic_medium: 'organic',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      percent_scrolled: 90,
      engagement_time_msec: 3865,
      page_title: 'Home',
      page_location: 'https://shop.googlemerchandisestore.com/store.html',
      debug_mode: 1,
      ga_session_number: 3,
      ga_session_id: 9157144569,
      engaged_session_event: 1,
      session_engaged: 1
    },
    ga_session_id: 9157144569
  },
  {
    __id: '1609920000000000|2219098.9178831126|view_promotion|-9056962888',
    event_date: 20210106,
    event_timestamp: 1609920000000000,
    event_name: 'view_promotion',
    user_pseudo_id: 2219098.9178831126,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      page_location: 'https://shop.googlemerchandisestore.com/store.html',
      ga_session_number: 1,
      session_engaged: 1,
      page_title: 'Home',
      ga_session_id: 716804610,
      engaged_session_event: 1,
      page_referrer:
        'https://shop.googlemerchandisestore.com/registersuccess.html?',
      engagement_time_msec: 108,
      debug_mode: 1
    },
    ga_session_id: 716804610
  },
  {
    __id: '1611740000000000|2230905.7046198924|scroll|8949707093',
    event_date: 20210127,
    event_timestamp: 1611740000000000,
    event_name: 'scroll',
    user_pseudo_id: 2230905.7046198924,
    traffic_medium: '(none)',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      campaign: '(organic)',
      ga_session_id: 1109039738,
      term: '<obfuscated>',
      source: 'google',
      debug_mode: 1,
      engagement_time_msec: 9216,
      engaged_session_event: 1,
      medium: 'organic',
      ga_session_number: 1,
      page_location: 'https://shop.googlemerchandisestore.com/',
      page_title: 'Home',
      session_engaged: 1,
      percent_scrolled: 90
    },
    ga_session_id: 1109039738
  },
  {
    __id: '1611350000000000|2325507.2899863417|session_start|-3633593671',
    event_date: 20210122,
    event_timestamp: 1611350000000000,
    event_name: 'session_start',
    user_pseudo_id: 2325507.2899863417,
    traffic_medium: 'organic',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      ga_session_id: 5474366524,
      ga_session_number: 1,
      page_title: 'YouTube | Shop by Brand | Google Merchandise Store',
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Shop+by+Brand/YouTube',
      engaged_session_event: 1
    },
    ga_session_id: 5474366524
  },
  {
    __id: '1611350000000000|2325507.2899863417|user_engagement|5415803729',
    event_date: 20210122,
    event_timestamp: 1611350000000000,
    event_name: 'user_engagement',
    user_pseudo_id: 2325507.2899863417,
    traffic_medium: 'organic',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      session_engaged: 1,
      page_referrer: 'https://shop.googlemerchandisestore.com/store.html?',
      source: 'shop.googlemerchandisestore.com',
      page_title: 'YouTube 25 oz Gear Cap Bottle Black',
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Drinkware/Youtube+25oz+gear+cap+bottle+black',
      engaged_session_event: 1,
      debug_mode: 1,
      medium: 'referral',
      campaign: '(referral)',
      ga_session_id: 5474366524,
      engagement_time_msec: 49817,
      ga_session_number: 1
    },
    ga_session_id: 5474366524
  },
  {
    __id: '1610610000000000|2351306.620910962|user_engagement|8188584095',
    event_date: 20210114,
    event_timestamp: 1610610000000000,
    event_name: 'user_engagement',
    user_pseudo_id: 2351306.620910962,
    traffic_medium: 'organic',
    device_category: 'mobile',
    browser: 'Safari',
    device_detail: 'mobile / Safari',
    event_value_in_usd: 0,
    params: {
      campaign: '(organic)',
      page_location: 'https://googlemerchandisestore.com/',
      debug_mode: 1,
      engagement_time_msec: 5641,
      engaged_session_event: 1,
      term: '<obfuscated>',
      ga_session_number: 1,
      page_title: 'Google Online Store',
      medium: 'organic',
      session_engaged: 1,
      source: 'google',
      ga_session_id: 9622942430
    },
    ga_session_id: 9622942430
  },
  {
    __id: '1610610000000000|2351306.620910962|scroll|-6635522960',
    event_date: 20210114,
    event_timestamp: 1610610000000000,
    event_name: 'scroll',
    user_pseudo_id: 2351306.620910962,
    traffic_medium: 'organic',
    device_category: 'mobile',
    browser: 'Safari',
    device_detail: 'mobile / Safari',
    event_value_in_usd: 0,
    params: {
      engagement_time_msec: 761,
      session_engaged: 1,
      ga_session_number: 1,
      page_location: 'https://googlemerchandisestore.com/',
      ga_session_id: 9622942430,
      percent_scrolled: 90,
      debug_mode: 1,
      engaged_session_event: 1,
      page_title: 'Google Online Store'
    },
    ga_session_id: 9622942430
  },
  {
    __id: '1610980000000000|2384954.218745844|session_start|5870747255',
    event_date: 20210118,
    event_timestamp: 1610980000000000,
    event_name: 'session_start',
    user_pseudo_id: 2384954.218745844,
    traffic_medium: '<Other>',
    device_category: 'desktop',
    browser: 'Edge',
    device_detail: 'desktop / Edge',
    event_value_in_usd: 0,
    params: {
      ga_session_number: 1,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel',
      engaged_session_event: 1,
      ga_session_id: 4533886078,
      page_title: 'Apparel | Google Merchandise Store'
    },
    ga_session_id: 4533886078
  },
  {
    __id: '1609880000000000|2510026.345211138|select_promotion|-5114053075',
    event_date: 20210105,
    event_timestamp: 1609880000000000,
    event_name: 'select_promotion',
    user_pseudo_id: 2510026.345211138,
    traffic_medium: 'referral',
    device_category: 'mobile',
    browser: '<Other>',
    device_detail: 'mobile / <Other>',
    event_value_in_usd: 0,
    params: {
      engagement_time_msec: 2,
      page_location: 'https://shop.googlemerchandisestore.com/',
      debug_mode: 1,
      session_engaged: 1,
      engaged_session_event: 1,
      ga_session_number: 1,
      page_title: 'Home',
      ga_session_id: 9763169697
    },
    ga_session_id: 9763169697
  },
  {
    __id: '1609930000000000|2589768.439253248|first_visit|6782987357',
    event_date: 20210106,
    event_timestamp: 1609930000000000,
    event_name: 'first_visit',
    user_pseudo_id: 2589768.439253248,
    traffic_medium: '<Other>',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      engaged_session_event: 1,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Accessories/Google+See+no+hear+no+set',
      page_title: 'Google See-No Hear-No Set',
      ga_session_id: 1372810478,
      session_engaged: 1,
      ga_session_number: 1
    },
    ga_session_id: 1372810478
  },
  {
    __id: '1610430000000000|2889241.838178414|view_item|-4974109382',
    event_date: 20210112,
    event_timestamp: 1610430000000000,
    event_name: 'view_item',
    user_pseudo_id: 2889241.838178414,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      engagement_time_msec: 392,
      engaged_session_event: 1,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Accessories/Android+Techie+3D+Framed+Art',
      ga_session_id: 5898277976,
      session_engaged: 1,
      ga_session_number: 1,
      debug_mode: 1,
      page_title: 'Android Techie 3D Framed Art'
    },
    ga_session_id: 5898277976
  },
  {
    __id: '1610430000000000|2889241.838178414|first_visit|3875282035',
    event_date: 20210112,
    event_timestamp: 1610430000000000,
    event_name: 'first_visit',
    user_pseudo_id: 2889241.838178414,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      ga_session_number: 1,
      page_title: 'Android Iconic Notebook',
      ga_session_id: 5898277976,
      engaged_session_event: 1,
      session_engaged: 1,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Office/Android+Iconic+Notebook'
    },
    ga_session_id: 5898277976
  },
  {
    __id: '1610430000000000|2889241.838178414|view_item|-9435026179',
    event_date: 20210112,
    event_timestamp: 1610430000000000,
    event_name: 'view_item',
    user_pseudo_id: 2889241.838178414,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      page_title: 'Google Campus Bike Carry Pouch',
      session_engaged: 1,
      debug_mode: 1,
      engagement_time_msec: 770,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Bags/Google+Google+Campus+Bike+Carry+Pouch',
      ga_session_id: 5898277976,
      ga_session_number: 1,
      engaged_session_event: 1
    },
    ga_session_id: 5898277976
  },
  {
    __id: '1610430000000000|2889241.838178414|page_view|3306541317',
    event_date: 20210112,
    event_timestamp: 1610430000000000,
    event_name: 'page_view',
    user_pseudo_id: 2889241.838178414,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      session_engaged: 1,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Office/Google+Recycled+Writing+Set',
      engaged_session_event: 1,
      ga_session_id: 5898277976,
      clean_event: 'gtm.js',
      ga_session_number: 1,
      page_title: 'Google Recycled Writing Set',
      debug_mode: 1
    },
    ga_session_id: 5898277976
  },
  {
    __id: '1611600000000000|3531543.061725483|view_promotion|-3952606910',
    event_date: 20210125,
    event_timestamp: 1611600000000000,
    event_name: 'view_promotion',
    user_pseudo_id: 3531543.061725483,
    traffic_medium: 'organic',
    device_category: 'mobile',
    browser: 'Safari',
    device_detail: 'mobile / Safari',
    event_value_in_usd: 0,
    params: {
      page_title: 'Home',
      ga_session_id: 3702926601,
      session_engaged: 1,
      debug_mode: 1,
      page_location: 'https://shop.googlemerchandisestore.com/',
      engaged_session_event: 1,
      ga_session_number: 1,
      engagement_time_msec: 83
    },
    ga_session_id: 3702926601
  },
  {
    __id: '1610970000000000|4011791.2269121925|view_promotion|-38960471',
    event_date: 20210118,
    event_timestamp: 1610970000000000,
    event_name: 'view_promotion',
    user_pseudo_id: 4011791.2269121925,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      engagement_time_msec: 196,
      ga_session_number: 2,
      engaged_session_event: 1,
      page_title: 'Home',
      session_engaged: 1,
      ga_session_id: 2175581168,
      page_location: 'https://shop.googlemerchandisestore.com/',
      debug_mode: 1
    },
    ga_session_id: 2175581168
  },
  {
    __id: '1609670000000000|4239675.220679819|page_view|-6268452253',
    event_date: 20210103,
    event_timestamp: 1609670000000000,
    event_name: 'page_view',
    user_pseudo_id: 4239675.220679819,
    traffic_medium: 'referral',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      page_location: 'https://shop.googlemerchandisestore.com/',
      page_title: 'Home',
      session_engaged: 1,
      clean_event: 'gtm.js',
      engaged_session_event: 1,
      ga_session_id: 77729219,
      ga_session_number: 1,
      debug_mode: 1
    },
    ga_session_id: 77729219
  },
  {
    __id: '1611340000000000|5188370.382780906|session_start|5822567921',
    event_date: 20210122,
    event_timestamp: 1611340000000000,
    event_name: 'session_start',
    user_pseudo_id: 5188370.382780906,
    traffic_medium: '<Other>',
    device_category: 'desktop',
    browser: 'Chrome',
    device_detail: 'desktop / Chrome',
    event_value_in_usd: 0,
    params: {
      engaged_session_event: 1,
      ga_session_number: 1,
      ga_session_id: 9674589155,
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel',
      page_title: 'Apparel | Google Merchandise Store'
    },
    ga_session_id: 9674589155
  },
  {
    __id: '1609600000000000|5428986.989179107|user_engagement|-895549809',
    event_date: 20210102,
    event_timestamp: 1609600000000000,
    event_name: 'user_engagement',
    user_pseudo_id: 5428986.989179107,
    traffic_medium: 'organic',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      debug_mode: 1,
      session_engaged: 1,
      ga_session_number: 1,
      engagement_time_msec: 3421,
      ga_session_id: 3704594243,
      page_title: 'Google Dino Game Tee',
      page_location:
        'https://shop.googlemerchandisestore.com/Google+Redesign/Apparel/Google+Dino+Game+Tee',
      engaged_session_event: 1
    },
    ga_session_id: 3704594243
  },
  {
    __id: '1609900000000000|5612330.689277568|page_view|-6171734046',
    event_date: 20210106,
    event_timestamp: 1609900000000000,
    event_name: 'page_view',
    user_pseudo_id: 5612330.689277568,
    traffic_medium: 'cpc',
    device_category: 'desktop',
    browser: 'Edge',
    device_detail: 'desktop / Edge',
    event_value_in_usd: 0,
    params: {
      page_title: 'Home',
      debug_mode: 1,
      engaged_session_event: 1,
      engagement_time_msec: 12,
      page_location: 'https://shop.googlemerchandisestore.com/',
      ga_session_number: 1,
      ga_session_id: 5060149289,
      session_engaged: 1
    },
    ga_session_id: 5060149289
  },
  {
    __id: '1610800000000000|5733492.116239125|page_view|3693075657',
    event_date: 20210116,
    event_timestamp: 1610800000000000,
    event_name: 'page_view',
    user_pseudo_id: 5733492.116239125,
    traffic_medium: '(none)',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      entrances: 1,
      clean_event: 'gtm.js',
      page_title: 'Home',
      debug_mode: 1,
      ga_session_number: 1,
      ga_session_id: 6478020992,
      engaged_session_event: 1,
      page_location: 'https://shop.googlemerchandisestore.com/store.html',
      session_engaged: 0
    },
    ga_session_id: 6478020992
  },
  {
    __id: '1611140000000000|5971348.017087772|user_engagement|8778019628',
    event_date: 20210120,
    event_timestamp: 1611140000000000,
    event_name: 'user_engagement',
    user_pseudo_id: 5971348.017087772,
    traffic_medium: '(none)',
    device_category: 'mobile',
    browser: 'Chrome',
    device_detail: 'mobile / Chrome',
    event_value_in_usd: 0,
    params: {
      campaign: '(direct)',
      session_engaged: 1,
      medium: '(none)',
      debug_mode: 1,
      engaged_session_event: 1
    }
  }
]
